import { IconAngleDoubleDown } from '@iwoca/icons';
import { IwocaLogo } from '@iwoca/orion';

import styles from './BankLinkPreview.module.css';
import previewBankConsent from './images/preview-bank-consent-page.png';
import previewBankLogin from './images/preview-bank-login.png';
import previewBankSelection from './images/preview-bank-selection-page.png';
import previewIntroPage from './images/preview-intro-page.png';
import previewSummary from './images/preview-summary.png';

export const BankLinkPreview = () => {
  return (
    <>
      <nav className={styles.previewNav}>
        <IwocaLogo className={styles.logo} />
      </nav>
      <section className={styles.bankLinkPreviewContainer}>
        <h1 className={styles.bankLinkPreviewTitle}>
          What your trusted third party will see when they use your secure
          shareable link.
        </h1>
        <img
          src={previewSummary}
          alt="Instructions on shareable link"
          className={styles.screenshot}
        />
        <div className={styles.scrollDown}>
          <IconAngleDoubleDown className={styles.scrollDownIcon} />
          <p className={styles.scrollDownContent}>
            Scroll down for further detail
          </p>
          <IconAngleDoubleDown className={styles.scrollDownIcon} />
        </div>
        <div>
          <hr className={styles.scrollDivider} />
        </div>
        <ol className={styles.screenshotList}>
          <li>
            <h2 className={styles.screenshotTitle}>
              Intro screen shows information about iwoca and what the customer
              is being asked to provide and why.
            </h2>
            <img
              src={previewIntroPage}
              alt="Intro page of agent journey"
              className={styles.screenshot}
            />
            <hr className={styles.screenshotBorder} />
          </li>
          <li>
            <h2 className={styles.screenshotTitle}>
              Choose the bank to link from the list of available banks.
            </h2>
            <img
              src={previewBankSelection}
              alt="Instructions on bank modal"
              className={styles.screenshot}
            />
            <hr className={styles.screenshotBorder} />
          </li>
          <li>
            <h2 className={styles.screenshotTitle}>
              We’ll show your third party which information you've authorised us
              to see.
            </h2>
            <img
              src={previewBankConsent}
              alt="Instructions on consent page"
              className={styles.screenshot}
            />
            <hr className={styles.screenshotBorder} />
          </li>
          <li>
            <h2 className={styles.screenshotTitle}>
              Log in via the bank to complete the link.
            </h2>
            <p className={styles.screenshotDescription}>
              The account is now linked and you will receive an email
              notification to continue your application. If you still have the
              application open in your browser, you will need to refresh the
              screen for the change to be reflected.
            </p>
            <img
              src={previewBankLogin}
              alt="Instructions on link bank login ui"
              className={styles.screenshot}
            />
          </li>
        </ol>
        <div className={styles.readyContainer}>
          <h2 className={styles.readyTitle}>Ready to share your link?</h2>
          <p className={styles.readyDescription}>
            Close this tab and return to your application. Share your secure
            shareable link with you trusted third party by whatever means you
            wish.
          </p>
        </div>
      </section>
    </>
  );
};
